/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {NotificationSearchResponse} from '../models/NotificationSearchResponse';
import type {SearchCriteria} from '../models/SearchCriteria';

export interface SearchNotification$Request {
    searchCriteria: SearchCriteria;
}

export interface SearchNotification$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchNotificationRequest = createAction<PayloadData<void, SearchNotification$Request>>('INTERNAL_NOTIFICATION_SEARCH__SEARCH_NOTIFICATION__REQUEST');
export const searchNotificationSuccess = createAction<PayloadData<NotificationSearchResponse, SearchNotification$Request>>('INTERNAL_NOTIFICATION_SEARCH__SEARCH_NOTIFICATION__SUCCESS');
export const searchNotificationFailure = createAction<PayloadData<Error, SearchNotification$Request, true>>('INTERNAL_NOTIFICATION_SEARCH__SEARCH_NOTIFICATION__FAILURE');

export const searchNotificationActions = [
    searchNotificationRequest,
    searchNotificationSuccess,
    searchNotificationFailure
] as const;

/**
 * @param {SearchCriteria} meta.searchCriteria
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchNotification = (meta: SearchNotification$Request, config?: SearchNotification$Config) => {
    return {
        CALL_API: {
            types: searchNotificationActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/internal-notifications/search`,
            TRANSPORT_REQUEST_BODY: meta.searchCriteria,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

